import { Component, Input, OnInit } from '@angular/core';
import { ParkingTariffLimitedDTO } from 'src/app/base/models/models.swagger.generated';
import { TranslateModule } from '@ngx-translate/core';


@Component({
    selector: 'app-subscription-details-tariffs',
    templateUrl: './subscription-details-tariffs.component.html',
    styleUrls: ['./subscription-details-tariffs.component.scss'],
    imports: [TranslateModule]
})
export class SubscriptionDetailsTariffsComponent implements OnInit {

  @Input() assignedTariffs: ParkingTariffLimitedDTO[];

  constructor() { }

  ngOnInit() {
  }

}
